import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderPmtrcp = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl='https://customsprem.gov.tc/';
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [tblrcp, setTblrcp] = useState([]);
const [dowait, setDowait] = useState({show:false});
const [btnsearch, setBtnsearch] = useState({clicks:0});

const [estab, setEstab] = useState({
	BL_CATEG:''
	, ESTAB_NAME:''
	, TAX_PAYER_NO:''
	, TAX_PAYER_NAME:''
	, DEPT_DESC:''
	});


const [searchcrit, setSearchcrit] = useState({
	date1:''
	, date2:''
	, permit_no:''
	, tax_payer_no:''
	, do_search: 0
	});




const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Receipts";	

if (tblrcp.length<1){
	getdefaultfinyrdates(2);
	//tblpaymtrcp();
	}//end if
	
 },[]);



/*
useEffect(() => {

if (searchcrit.do_search==1)
	tblpaymtrcp();

},[searchcrit.do_search]);

*/ 

useEffect(() => {

if (document.getElementsByName("permit_no")[0])
	document.getElementsByName("permit_no")[0].focus();

 },[JSON.stringify(tblrcp)]);



function handleChange(e){
	
	const {name, value}=e.target;
console.log("handleChange name: "+name+' '+value);

if (name=="permit_no"){
	if (value.trim()==""){
		if (!document.getElementById("btnsearch").classList.contains("hidden"))
			document.getElementById("btnsearch").classList.add("hidden");
		}
	else{
		if (document.getElementById("btnsearch").classList.contains("hidden"))
			document.getElementById("btnsearch").classList.remove("hidden");
		}
	}//end if

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if

async function getdefaultfinyrdates(yrs){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {yrs:yrs} )
  };		

  await fetch(customspremurl+'rarprfc/getdefaultfinyrdates',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetdefaultfinyrdates(res) )
      .catch(err => console.log(err));

}//end func


function aftergetdefaultfinyrdates(res){

if (!res.length)
	return;
	
setSearchcrit((prev)=>{
	return {...prev
		, date1:res[0].DATE1
		, date2:res[0].DATE2
		}
	});
	
}//end func	


async function tblpaymtrcp(){

if (searchcrit.permit_no.trim()==""){
	window.alert("enter permit_no to search");
	return;
	}

let params = searchcrit;

console.log("tblpaymtrcp: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setTblrcp([]);
setDowait({show:true});
if (!document.getElementById("btnsearch").classList.contains("hidden"))
	document.getElementById("btnsearch").classList.add("hidden");

  await fetch(customspremurl+'rarprfc/tblpaymtrcp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertblpaymtrcp(res) )
      .catch(err => console.log(err));

}//end func


function aftertblpaymtrcp(res){

setDowait({show:false});
if (document.getElementById("btnsearch").classList.contains("hidden"))
	document.getElementById("btnsearch").classList.remove("hidden");
		
setSearchcrit((prev)=>{
	return {...prev
		, do_search:0
		}
	});

setBtnsearch({clicks:btnsearch.clicks+1});

if (!res.length)
	return;
	
let htmrows=[];

res.map((col, index) => {
	const trkey='tr_'+index;
	const rdkey='td_'+index;

	if (index==0){
		setSearchcrit((prev)=>{
			return {...prev, date1:col['DATE1'], date2:col['DATE2']}	
			});
		setEstab((prev)=>{
			return {...prev
				, BL_CATEG:col['BL_CATEG']
				, ESTAB_NAME:col['ESTAB_NAME']
				, TAX_PAYER_NO:col['TAX_PAYER_NO']
				, TAX_PAYER_NAME:col['TAX_PAYER_NAME']
				, DEPT_DESC:col['DEPT_DESC']
				}	
			});
		}//end if

		
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='left' >{col['DEPT_DESC']}</td>
	<td align='left' >{col['DOC_TYPE_DESC']}</td>
	<td align='center' >{col['TRANS_DATE']}</td>
	<td align='center' title={col['RECEIPT_VOUCHER_NO']} >{col['DOC_NO']}</td>
	<td align='right' >{col['AMOUNT'].toFixed(2)}</td>
	<td align='left' >{col['RECEIPT_VOUCHER_COMMENT']}</td>
	</tr>;
	htmrows.push(htmrow);
/*
			<th>Establishment Name</th>
			<th>Customer #</th>
			<th>Customer Name</th>
			<th>Department</th>

*/

});	

setTblrcp(htmrows);	
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

if (!document.getElementById("btnsave").classList.contains("hidden"))
	document.getElementById("btnsave").classList.add("hidden");
		
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func




	
	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Revenue Receipts
	</p>

	<table align="center" style={{marginTop:"0px"}}  >
	<tbody>
	<tr>
	<td align="center" >
		start date:<input name="date1" type="date" value={searchcrit.date1} onChange={(e)=>{handleChange(e);}} />
	</td>

	<td align="center" >
		end date:<input name="date2" type="date" value={searchcrit.date2} onChange={(e)=>{handleChange(e);}} />
	</td>
	</tr>

	<tr>
	<td align="center" >
		Business License No.: <input name="permit_no" type="text" size="9" value={searchcrit.permit_no} placeholder="e.g. 18168" autoComplete="off" style={{textAlign:"center"}} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}}  />
	</td>

	<td align="center" >
		<button id="btnsearch" className="button hidden" onClick={(e)=>{tblpaymtrcp();}} >search</button>
	</td>

	</tr>
	</tbody>
	</table>

	{dowait.show && <div  align='center'  ><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
	{
	!dowait.show && tblrcp.length==0 && btnsearch.clicks>0 && <div align='center' style={{marginTop:"18px"}} >the search produced no results</div>
	}
	{
	!dowait.show && tblrcp.length>0 && <>
		<table align='center' style={{backgroundColor:"gainsboro"}} >
		<tbody>
		<tr>
			<td align='right' >Business Name: </td>
			<td align='left' style={{fontWeight:"bold"}}  >{estab.ESTAB_NAME}</td>
		</tr>
		<tr>
			<td align='right' >Business Category: </td>
			<td align='left' style={{fontWeight:"bold"}}  >{estab.BL_CATEG}</td>
		</tr>
		<tr>
			<td align='right'  >Customer Name: </td>
			<td align='left' style={{fontWeight:"bold"}}  >{estab.TAX_PAYER_NAME}</td>
		</tr>
		</tbody>
		</table>

		<table align='center' className='customers' style={{marginTop:"12px",width:"85%"}} >
		<thead>
		<tr>
			<th>#</th>
			<th>Department</th>
			<th>Document<br/>Type</th>
			<th>Transaction<br/>Date</th>
			<th>Document #</th>
			<th>Amount</th>
			<th>Comment</th>
		</tr>
		</thead>

		<tbody>
		{tblrcp}
		</tbody>
		</table>
		</>
	}		

	{/*
		<th>Ministry</th>
	<td align='left' >{col['MINISTRY']}</td>
	
	*/}



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderPmtrcp;